<template>
  <v-toolbar
      class="neris-stations-toolbar"
      flat
  >
    <v-text-field
        v-model="filtersData.search"
        hide-details
        class="mr-5"
        label="Search"
        style="max-width: 230px"
    />
    <v-spacer />
    <v-btn
        class="mr-3"
        color="primary"
        @click="$emit('add')"
    >
      + Add
    </v-btn>
  </v-toolbar>
</template>
<script>

export default {
  name: 'Toolbar',
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filtersData: this.filters,
    };
  },
  watch: {
    filtersData: {
      handler() {
        this.$emit('search', this.filtersData);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.neris-stations-toolbar {
  z-index: 10;
}
</style>
